import { render, staticRenderFns } from "./OfflineLifecycle.vue?vue&type=template&id=4a5d3d85&scoped=true"
import script from "./OfflineLifecycle.vue?vue&type=script&lang=js"
export * from "./OfflineLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5d3d85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projekte\\Tipsiolive\\tipsiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a5d3d85')) {
      api.createRecord('4a5d3d85', component.options)
    } else {
      api.reload('4a5d3d85', component.options)
    }
    module.hot.accept("./OfflineLifecycle.vue?vue&type=template&id=4a5d3d85&scoped=true", function () {
      api.rerender('4a5d3d85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lifecycle/OfflineLifecycle.vue"
export default component.exports